import type { FooterBrandingData } from '@/data/types';

interface FooterBrandingProps {
  data: FooterBrandingData;
}

export function FooterBranding({ data }: FooterBrandingProps) {
  return (
    <footer className="bg-red-600 text-white py-12">
      <div className="container mx-auto px-4">
        {/* Car Talk Section */}
        <div className="text-center mb-8">
          <div className="grid md:grid-cols-3 gap-8 items-center">
            <div>
              <h3 className="text-xl font-bold mb-2">
                {data.carTalkSection.title}
              </h3>
              <h4 className="text-lg text-red-200">
                {data.carTalkSection.subtitle}
              </h4>
            </div>
            
            <div className="flex justify-center">
              {/* Car Talk Logo placeholder - would use actual image if available */}
              <div className="w-32 h-24 bg-white rounded-lg flex items-center justify-center">
                <span className="text-red-600 font-bold text-sm">CAR TALK</span>
              </div>
            </div>
            
            <div>
              <a
                href={data.carTalkSection.linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-red-600 px-6 py-3 rounded-md font-bold hover:bg-gray-100 transition-colors"
              >
                {data.carTalkSection.callToAction}
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-red-500 pt-6">
          <p className="text-center text-red-200 text-sm">
            {data.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}